export default __webpack_public_path__ + "static/media/4.6fddece1.JPG";